import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="bg-white text-[#228B22] p-2 shadow-md">
      <div className="container mx-auto">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <Link 
            to="/" 
            className="text-xl sm:text-3xl font-bold font-['Orbitron'] tracking-[0.1em] sm:tracking-[0.15em] bg-gradient-to-l from-green-600 via-green-500 to-green-400 bg-clip-text text-transparent drop-shadow-[0_0_8px_rgba(34,255,34,0.5)] mb-1"
            style={{
              textShadow: `
                0 0 20px rgba(34,255,34,0.5),
                0 0 40px rgba(34,255,34,0.3),
                inset 0 0 10px rgba(255,255,255,0.8),
                0 0 5px rgba(255,255,255,0.5)
              `,
              filter: 'drop-shadow(0 0 4px rgba(34,255,34,0.6))'
            }}
          >
            TACOMA OFF MARKET
          </Link>
          
          {/* Navigation - Always visible */}
          <div className="flex flex-wrap justify-center gap-x-3 gap-y-0.5 text-xs sm:text-xs">
            <Link to="/" className="hover:text-green-700 py-1 px-1.5">Home</Link>
            <Link to="/how-it-works" className="hover:text-green-700 py-1 px-1.5">How It Works</Link>
            <Link to="/about" className="hover:text-green-700 py-1 px-1.5">About</Link>
            <Link to="/contact" className="hover:text-green-700 py-1 px-1.5">Contact</Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 